import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Ng2IzitoastService } from 'ng2-izitoast';
import { CatalogosService } from 'src/app/services/catalogos.service';
import { LoginService } from 'src/app/services/login.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-gastos',
  templateUrl: './gastos.component.html',
  styleUrls: ['./gastos.component.scss']
})
export class GastosComponent implements OnInit {
  enviroment = environment.BASE_URL;
  respuestaGet:any;
  respuestaAdd:any;
  respuestaEdit:any;
  respuestaUpdate:any;

  formulario:any;
  formularioEdit:any;
  filtro:any;

  gastos:any;
  categorias:any;

  datosCliente:any;

  data:any;
  datosGasto:any;

  gastoId:any;
  sumaGastos:any;
  sumaPagos:any;

  fecha_inicio;
  fecha_fin;

  fecha_inicioD;
  fecha_finD;
  fecha;
  fechaEdit;

  utilidad:any;

  clasificaciones:any;

  categoriasF:any;

  constructor(private modalService:NgbModal, private _gastos:CatalogosService, private _getData:LoginService,
    private iziToast:Ng2IzitoastService) { }

  ngOnInit(): void {
    this.formulario = {
      'concepto':'',
      'categoria':'',
      'monto':'',
      'fecha':'',
    }

    this.formularioEdit = {
      'concepto':'',
      'categoria':'',
      'monto':'',
      'fecha':'',
    }

    this.filtro = {
      'fecha_inicio':'',
      'fecha_fin':'',
      'categoria':'',
      'clasificacion': '',
    }

    this.getDataCliente();
    this.getGastos();
    this.getCategoriasGasto();
    this.getClasificacionesGasto();
  }

  getDataCliente(){
    this._getData.getDataCliente().subscribe(
      data => {
        this.respuestaGet = data;
        if(this.respuestaGet.success){
          this.datosCliente = this.respuestaGet.content;
        
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error))
  }

  getCategoriasGasto(){
    this._gastos.getCategoriasGasto().subscribe(
      data => {
        this.respuestaGet = data;
        if(this.respuestaGet.success){
          this.categorias = this.respuestaGet.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  } 

  getClasificacionesGasto(){
    this._gastos.getClasificacionesGasto().subscribe(
      data => {
        this.respuestaGet = data;
        if(this.respuestaGet.success){
          this.clasificaciones = this.respuestaGet.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  getCategoriasGastoClasificacion(){
    this.data = {
      'clasificacion':this.filtro.clasificacion
    }

    this._gastos.getCategoriasGastoClasificacion(this.data).subscribe(
      data => {
        this.respuestaGet = data;
        if(this.respuestaGet.success){
          this.categoriasF = this.respuestaGet.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  getGastos(){
    this._gastos.getGastos().subscribe(
      data => {
        this.respuestaGet = data;
        if(this.respuestaGet.success){
          this.gastos = this.respuestaGet.content;
          this.sumaGastos = this.respuestaGet.gastos;
          this.sumaPagos = this.respuestaGet.pagos;
          this.utilidad = this.sumaPagos-this.sumaGastos
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  } 

  getGastosFiltrados(){

    if (this.filtro.fecha_inicio != null){
      this.fecha_inicio = this.filtro.fecha_inicio['year']+'-'+this.filtro.fecha_inicio['month']+'-'+this.filtro.fecha_inicio['day']
    }

    if (this.filtro.fecha_fin != null){
      this.fecha_fin = this.filtro.fecha_fin['year']+'-'+this.filtro.fecha_fin['month']+'-'+this.filtro.fecha_fin['day']
    }


    this.data = {
      'fecha_fin':this.fecha_fin,
      'fecha_inicio':this.fecha_inicio,
      'categoria':this.filtro.categoria,
      'clasificacion':this.filtro.clasificacion,
    }

    this._gastos.getGastosFiltrados(this.data).subscribe(
      data => {
        this.respuestaGet = data;
        if(this.respuestaGet.success){
          this.gastos = this.respuestaGet.content;
          this.sumaGastos = this.respuestaGet.gastos;
          this.sumaPagos = this.respuestaGet.pagos;
          this.utilidad = this.sumaPagos-this.sumaGastos

        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  } 

  imageChange(files: FileList){
    this.formulario.imagen = files.item(0);
  // || this.invoice.ticket.type.toString() !== 'image/jpeg'
    if (this.formulario.imagen.type.toString() == 'image/png' ||
        this.formulario.imagen.type.toString() == 'image/jpeg' ) {
        if (this.formulario.imagen.size > 10485760) {
          this.formulario.imagen = null;
          $('#imagen').focus();
          return;
        }
        console.log('File Change', this.formulario.imagen);
    } else {
      this.formulario.imagen = null;
      $('#imagen').focus();
      return;
    }
  }
  
  agregarGasto(){
    if (this.formulario.fecha != null){
      this.fecha = this.formulario.fecha['year']+'-'+this.formulario.fecha['month']+'-'+this.formulario.fecha['day']
    }

    const formData = new FormData();
    formData.append('fecha', this.fecha);
    formData.append('concepto', this.formulario.concepto);
    formData.append('categoria', this.formulario.categoria);
    formData.append('monto', this.formulario.monto);
    if (this.formulario.imagen){ 
      formData.append('imagen', this.formulario.imagen);
    }

    this._gastos.agregarGasto(formData).subscribe(
      data => {
        this.respuestaAdd = data;
        if(this.respuestaAdd.success){
          this.iziToast.show(
            {
                title: 'Se ha agregado correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.formulario.concepto = '';
          this.formulario.monto = '';
          this.formulario.categoria = '';
          this.dismissAll();
          this.getGastosFiltrados();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));

  }

  imageChangeEdit(files: FileList){
    this.formularioEdit.imagen = files.item(0);
  // || this.invoice.ticket.type.toString() !== 'image/jpeg'
    if (this.formularioEdit.imagen.type.toString() == 'image/png' ||
        this.formularioEdit.imagen.type.toString() == 'image/jpeg' ) {
        if (this.formularioEdit.imagen.size > 10485760) {
          this.formularioEdit.imagen = null;
          $('#imagen2').focus();
          return;
        }
        console.log('File Change', this.formularioEdit.imagen);
    } else {
      this.formularioEdit.imagen = null;
      $('#imagen2').focus();
      return;
    }
  }

  editarGasto(gasto:any){
    this.data = {
      'gasto':gasto
    }

    this._gastos.editarGasto(this.data).subscribe(
      data => {
        this.respuestaEdit = data;
        if(this.respuestaEdit.success){
          this.datosGasto = this.respuestaEdit.content;
          this.dismissAll();

          this.formularioEdit.concepto = this.datosGasto.concepto;
          this.formularioEdit.monto = this.datosGasto.monto;
          this.formularioEdit.categoria = this.datosGasto.categoria;
          this.formularioEdit.imagen = this.datosGasto.imagen;

          this.formularioEdit.fecha = this.datosGasto.fecha;
          if (this.formularioEdit.fecha != null){
            var anio_pago1 = this.formularioEdit.fecha.split('-')[0];
            var mes_pago1 = this.formularioEdit.fecha.split('-')[1];
            var dia_pago1 = this.formularioEdit.fecha.split('-')[2];

            anio_pago1 = parseInt(anio_pago1, 10);
            mes_pago1 = parseInt(mes_pago1, 10);
            dia_pago1 = parseInt(dia_pago1, 10);

            this.formularioEdit.fecha =  {year: anio_pago1, month: mes_pago1, day: dia_pago1};
          }

          document.getElementById('clickEditar').click();
          this.gastoId = this.datosGasto.id;

        }else{
          alert('No se cargaron los datos');
        }
      })

   
  }

  updateGasto(gasto:any){

    if (this.formularioEdit.fecha != null){
      this.fechaEdit = this.formularioEdit.fecha['year']+'-'+this.formularioEdit.fecha['month']+'-'+this.formularioEdit.fecha['day']
    }

    const formData = new FormData();
    formData.append('fecha', this.fechaEdit);
    formData.append('concepto', this.formularioEdit.concepto);
    formData.append('categoria', this.formularioEdit.categoria);
    formData.append('monto', this.formularioEdit.monto);
    formData.append('gasto', gasto);
    if (this.formularioEdit.imagen){ 
      formData.append('imagen', this.formularioEdit.imagen);
    }

    this._gastos.updateGasto(formData).subscribe(
      data => {
        this.respuestaAdd = data;
        if(this.respuestaAdd.success){
          this.iziToast.show(
            {
                title: 'Se ha actualizado correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.formularioEdit.concepto = '';
          this.formularioEdit.monto = '';
          this.formularioEdit.categoria = '';
          this.dismissAll();
          this.getGastosFiltrados();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  eliminarGasto(gasto:any){
    this.data = {
      'gasto':gasto
    }

    this._gastos.eliminarGasto(this.data).subscribe(
      data => {
        this.respuestaUpdate = data;
        if(this.respuestaUpdate.success){
          this.iziToast.show(
            {
                title: 'Se ha eliminado correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.getGastosFiltrados();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  descargarExcel(categoria, clasificacion){
    if (this.filtro.fecha_inicio != null){
      this.fecha_inicioD = this.filtro.fecha_inicio['year']+'-'+this.filtro.fecha_inicio['month']+'-'+this.filtro.fecha_inicio['day']
    }

    if (this.filtro.fecha_fin != null){
      this.fecha_finD = this.filtro.fecha_fin['year']+'-'+this.filtro.fecha_fin['month']+'-'+this.filtro.fecha_fin['day']
    }

    window.location.replace(this.enviroment+'/api/descargarExcelGastos?categoria='+categoria+'&clasificacion='+clasificacion+'&fecha_fin='+this.fecha_finD+'&fecha_inicio='+this.fecha_inicioD);
  }

  openModal(modal) {
    this.modalService.open(modal, { size: 'lg' });
  }

  openModal2(modal) {
    this.modalService.open(modal, {size: 'lg'});
  }

  dismissAll() {
    this.modalService.dismissAll();
  }

}
